import { AxiosService } from 'services';
export function UpdateBrandService(formData, id) {

  return AxiosService().post(`brand/update?idBrand=${id}`, formData)
    .then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
}
